export default "__VITE_ASSET__231aaffa__"